var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-tag__wrapper",class:( _obj = {}, _obj['with-delete'] = !!_vm.withDelete, _obj['prevent-ellipsis'] = _vm.preventEllipsis, _obj )},[_c('span',[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),(_vm.withDelete)?_c('i',_vm._g({staticClass:"fal fa-times"},
        _vm.removeHandler ? { click: function (e) { return _vm.removeHandler(e, _vm._key, _vm.label); } } : {}
      )):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }